import { TableCell, TableRow } from "../../../design/table";
import type { DiscoveryRequest } from "../../../models/DiscoveryRequest";
import moment from "moment";
import { Subheading } from "../../../design/heading";
import DiscoveryRequestStatusBadge from "../../../components/DiscoveryRequestStatusBadge";
import ParticipantSideBadge from "../../../components/ParticipantSideBadge";

interface DiscoveryRequestListItemProps {
  discoveryRequest: DiscoveryRequest;
}

const DiscoveryRequestListItem: React.FC<DiscoveryRequestListItemProps> = ({
  discoveryRequest,
}) => {
  return (
    <TableRow
      key={discoveryRequest._id}
      href={`/discovery-request/${discoveryRequest._id}`}
    >
      <TableCell className="flex flex-col">
        <Subheading>{discoveryRequest.title}</Subheading>
        <span>{discoveryRequest.description}</span>
      </TableCell>
      <TableCell>
        <ParticipantSideBadge side={discoveryRequest.side} />
      </TableCell>
      <TableCell>{moment(discoveryRequest.dueDate).format("LL")}</TableCell>
      <TableCell>
        {discoveryRequest.status && (
          <DiscoveryRequestStatusBadge status={discoveryRequest.status} />
        )}
      </TableCell>
    </TableRow>
  );
};

export default DiscoveryRequestListItem;
